<form [formGroup]="enrollmentFrm" [class.mt-2]="mode === 'UPDATE'" appFocusInvalidElement
    #focusInvalidElement="focusInvalidElement">
    <p-accordion  [activeIndex]="0"> 
        <p-accordionTab  [header]="'Practice Information'" >
            <div class="d-flex flex-wrap flex-column col-12">
                <label for="" class="col-form-label" id="lblPracticeName">Practice Name
                    <app-required-label></app-required-label>
                </label>
                <input type="text" id="txtPracticeName" class="form-control form-control-sm text-uppercase"
                    formControlName="practiceName" [ngClass]="{'is-invalid': isControlInvalid(f.practiceName)}"
                    placeholder="Practice Name" maxlength="100">
                <app-error [caption]="'Practice Name'" [control]="f.practiceName" [isSubmit]="submit"
                    class="invalid-feedback">
                </app-error>
            </div>
            <div class="d-flex flex-wrap justify-content-start row">
                <div class="d-flex flex-column col-auto">
                    <label for="" class="col-form-label" id="lblEnrolledInNJIIS">Are you enrolled in NJIIS?
                        <app-required-label>
                        </app-required-label>
                    </label>
                    <app-select id="selEnrollInNJIIS" [options]="enrollNJIISList" formControlName="enrolledInNJIIS"
                        (changeEvent)="enrolledInNJIISChange()"
                        [ngClass]="{'is-invalid': isControlInvalid(f.enrolledInNJIIS)}"
                        [isInvalid]="isControlInvalid(f.enrolledInNJIIS)">
                    </app-select>
                    <app-error [caption]="'Enrolled In NJIIS'" [control]="f.enrolledInNJIIS" [isSubmit]="submit"
                        class="invalid-feedback">
                    </app-error>
                </div>
                <div class="d-flex flex-column col-auto">
                    <label for="" class="col-form-label" id="lblNJIISFacId">NJIIS Facility Id <app-required-label
                            *ngIf="f.enrolledInNJIIS.value == 'Y'">
                        </app-required-label> </label>
                    <input type="text" id="txtNJIISFacId" formControlName="njiisFacilityId"
                        class="form-control form-control-sm"
                        [ngClass]="{'is-invalid': isControlInvalid(f.njiisFacilityId)}" placeholder="NJIIS Facility Id"
                        maxlength="6">
                    <app-error [caption]="'NJIIS Facility Id'" [control]="f.njiisFacilityId" [isSubmit]="submit"
                        class="invalid-feedback">
                    </app-error>
                </div>
                <div class="d-flex flex-column col-auto">
                    <label for="" class="col-form-label" id="lblVfcPin">Practive VFC Pin (if applicable) </label>
                    <input type="text" id="txtVFCPin" formControlName="vfcPin" class="form-control form-control-sm"
                        [ngClass]="{'is-invalid': isControlInvalid(f.vfcPin)}" placeholder="Alphanumeric" maxlength="6">
                    <app-error [caption]="'VFC Pin'" [control]="f.vfcPin" [isSubmit]="submit" class="invalid-feedback">
                    </app-error>
                </div>
                <div class="d-flex flex-column col-xl-2 col-md-4 col-sm-12">
                    <label class="col-form-label">Tax ID <app-required-label></app-required-label></label>
                    <p-inputMask type="text" styleClass="form-control form-control-sm" formControlName="taxId"
                        [ngClass]="{'is-invalid': isControlInvalid(f.taxId)}" mask="99-9999999"
                        placeholder="__-_______">
                    </p-inputMask>
                    <app-error [isSubmit]="submit" [control]="f.taxId" [caption]="'Tax ID'" class="invalid-feedback">
                    </app-error>
                </div>
            </div>
            <div class="d-flex flex-wrap justify-content-start row">
                <div class="d-flex flex-column col-xl-6 col-md-6 col-sm-12">
                    <label for="" class="col-form-label" id="lblAddressLine1">Practice Physical Address Line 1
                        <app-required-label></app-required-label></label>
                    <input type="text" id="txtAddresLine1" formControlName="addressLine1"
                        class="form-control form-control-sm text-uppercase"
                        [ngClass]="{'is-invalid': isControlInvalid(f.addressLine1)}" placeholder="Street Address"
                        maxlength="50">
                    <app-error [caption]="'Address Line 1'" [control]="f.addressLine1" [isSubmit]="submit"
                        class="invalid-feedback">
                    </app-error>
                </div>
                <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-12">
                    <label for="" class="col-form-label" id="lblAddressLine2">Practice Physical Address Line 2 </label>
                    <input type="text" id="txtAddresLine2" formControlName="addressLine2"
                        class="form-control form-control-sm text-uppercase"
                        [ngClass]="{'is-invalid': isControlInvalid(f.addressLine2)}"
                        placeholder="P.O.BOX/APT/SUITE NUMBER" maxlength="50">
                    <app-error [caption]="'Address Line 2'" [control]="f.addressLine2" [isSubmit]="submit"
                        class="invalid-feedback">
                    </app-error>
                </div>
                <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-12">
                    <label for="" class="col-form-label" id="lblCity">City
                        <app-required-label></app-required-label></label>
                    <input type="text" id="txtCity" formControlName="city"
                        class="form-control form-control-sm text-uppercase"
                        [ngClass]="{'is-invalid': isControlInvalid(f.city)}" placeholder="City" maxlength="34">
                    <app-error [caption]="'City'" [control]="f.city" [isSubmit]="submit" class="invalid-feedback">
                    </app-error>
                </div>
                <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-12">
                    <label for="" class="col-form-label" id="lblState">State <app-required-label></app-required-label>
                    </label>
                    <app-select [options]="stateList" id="selState" formControlName="state"
                        [ngClass]="{'is-invalid': isControlInvalid(f.state)}" [isInvalid]="isControlInvalid(f.state)"
                        [orderBy]="'DESCR'" (changeEvent)="stateChange()">
                    </app-select>
                    <app-error [caption]="'State'" [control]="f.state" [isSubmit]="submit" class="invalid-feedback">
                    </app-error>
                </div>
                <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-12">
                    <label for="" class="col-form-label" id="lblZip">Zip
                        <app-required-label></app-required-label></label>
                    <p-inputMask type="text" id="selZip" formControlName="zip" styleClass="form-control form-control-sm"
                        [ngClass]="{'is-invalid': isControlInvalid(f.zip)}" mask="99999?-9999">
                    </p-inputMask>
                    <app-error [caption]="'Zip'" [control]="f.zip" [isSubmit]="submit" class="invalid-feedback">
                    </app-error>
                </div>
                <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-12">
                    <label for="" class="col-form-label" id="lblCounty">County <app-required-label></app-required-label>
                    </label>
                    <app-select [options]="countyMuniList" id="selCounty" [optionValue]="'countyCode'"
                        [label]="'countyName'" formControlName="countyCode"
                        [ngClass]="{'is-invalid': isControlInvalid(f.countyCode)}"
                        [isInvalid]="isControlInvalid(f.countyCode)" [orderBy]="'UNKNOWN_AT_END'"
                        (changeEvent)="countyChange()">
                    </app-select>
                    <app-error [caption]="'County'" [control]="f.countyCode" [isSubmit]="submit"
                        class="invalid-feedback">
                    </app-error>
                </div>
                <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-12">
                    <label for="" class="col-form-label" id="lblMunicipality">Municipality <app-required-label>
                        </app-required-label></label>
                    <app-select [options]="municipalityList" id="selMunicipality" [optionValue]="'municipalityCode'"
                        [label]="'municipalityName'" formControlName="municipalityCode"
                        [ngClass]="{'is-invalid': isControlInvalid(f.municipalityCode)}"
                        [isInvalid]="isControlInvalid(f.municipalityCode)" [orderBy]="'UNKNOWN_AT_END'">
                    </app-select>
                    <app-error [caption]="'Municipality'" [control]="f.municipalityCode" [isSubmit]="submit"
                        class="invalid-feedback">
                    </app-error>
                </div>
            </div>
        </p-accordionTab >
    </p-accordion>
    <p-accordion  [activeIndex]="0">
        <p-accordionTab  [header]="'Primary Contact'" class="mt-2">
            <div class="d-flex flex-wrap justify-content-start row">
                <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-12">
                    <label for="" class="col-form-label" id="lblPrimaryLastName">Contact Last Name <app-required-label>
                        </app-required-label></label>
                    <input type="text" id="txtPrimaryLastName" formControlName="primaryContactLastName"
                        class="form-control form-control-sm text-uppercase"
                        [ngClass]="{'is-invalid': isControlInvalid(f.primaryContactLastName)}" placeholder="Last Name"
                        maxlength="30">
                    <app-error [isSubmit]="submit" [control]="f.primaryContactLastName" [caption]="'Last Name'"
                        class="invalid-feedback">
                    </app-error>
                </div>
                <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-12">
                    <label for="" class="col-form-label" id="lblFirstName">Contact First Name <app-required-label>
                        </app-required-label></label>
                    <input type="text" id="txtPrimaryFirstName" formControlName="primaryContactFirstName"
                        class="form-control form-control-sm text-uppercase"
                        [ngClass]="{'is-invalid': isControlInvalid(f.primaryContactFirstName)}" placeholder="First Name"
                        maxlength="30">
                    <app-error [isSubmit]="submit" [control]="f.primaryContactFirstName" [caption]="'First Name'"
                        class="invalid-feedback">
                    </app-error>
                </div>
                <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-12">
                    <label for="" class="col-form-label" id="lblPrimaryMiddleName">Middle Name</label>
                    <input type="text" id="txtPrimaryMiddleName" formControlName="primaryContactMiddleName"
                        class="form-control form-control-sm text-uppercase"
                        [ngClass]="{'is-invalid': isControlInvalid(f.primaryContactMiddleName)}"
                        placeholder="Middle Name" maxlength="30">
                    <app-error [isSubmit]="submit" [control]="f.primaryContactMiddleName" [caption]="'Middle Name'"
                        class="invalid-feedback">
                    </app-error>
                </div>
                <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-12">
                    <label for="" class="col-form-label" id="lblPrimaryTitle">Title</label>
                    <input type="text" id="txtPrimaryTitle" formControlName="primaryTitle"
                        class="form-control form-control-sm text-uppercase"
                        [ngClass]="{'is-invalid': isControlInvalid(f.primaryTitle)}" placeholder="Title" maxlength="25">
                    <app-error [isSubmit]="submit" [control]="f.primaryTitle" [caption]="'Title'"
                        class="invalid-feedback">
                    </app-error>
                </div>
                <div class="d-flex flex-column col-xl-2 col-md-auto">
                    <label class="col-form-label" id="lblPrimaryPhone">Phone <app-required-label></app-required-label>
                    </label>
                    <p-inputMask type="text" id="txtPrimaryPhone" styleClass="form-control form-control-sm"
                        formControlName="primaryPhone" [ngClass]="{'is-invalid': isControlInvalid(f.primaryPhone)}"
                        mask="(999)999-9999">
                    </p-inputMask>
                    <app-error [isSubmit]="submit" [control]="f.primaryPhone" [caption]="'Phone'"
                        class="invalid-feedback">
                    </app-error>
                </div>
                <div class="d-flex flex-column col-xl-1 col-md-auto">
                    <label class="col-form-label" id="lblPrimaryExtn">Extn </label>
                    <p-inputMask type="text" id="txtPrimaryExtn" styleClass="form-control form-control-sm"
                        formControlName="primaryPhoneExtn"
                        [ngClass]="{'is-invalid': isControlInvalid(f.primaryPhoneExtn)}" mask="?99999">
                    </p-inputMask>
                    <app-error [isSubmit]="submit" [control]="f.primaryPhoneExtn" [caption]="'Phone Extn'"
                        class="invalid-feedback">
                    </app-error>
                </div>
                <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-auto">
                    <label class="col-form-label" id="lblPrimaryEmail">Email <app-required-label></app-required-label>
                    </label>
                    <input type="text" id="txtPrimaryEmail" class="form-control form-control-sm"
                        formControlName="primaryEmail" [ngClass]="{'is-invalid': isControlInvalid(f.primaryEmail)}"
                        placeholder="Email" maxlength="50">
                    <app-error [isSubmit]="submit" [control]="f.primaryEmail" [caption]="'Email'"
                        class="invalid-feedback">
                    </app-error>
                </div>
                <div class="d-flex flex-column col-xl-2 col-md-auto">
                    <label class="col-form-label" id="lblPrimaryFax">Fax </label>
                    <p-inputMask type="text" id="txtPrimaryFax" styleClass="form-control form-control-sm"
                        formControlName="primaryFax" [ngClass]="{'is-invalid': isControlInvalid(f.primaryFax)}"
                        mask="(999)999-9999">
                    </p-inputMask>
                    <app-error [isSubmit]="submit" [control]="f.primaryFax" [caption]="'Fax'" class="invalid-feedback">
                    </app-error>
                </div>
            </div>
        </p-accordionTab >
    </p-accordion>
    <p-accordion  [activeIndex]="0">
        <p-accordionTab  [header]="'Backup Contact'"  class="mt-2">
            <div class="d-flex flex-wrap justify-content-start row">
                <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-12">
                    <label for="" class="col-form-label" id="lblbackupLastName">Contact Last Name</label>
                    <input type="text" id="txtbackupLastName" formControlName="backupContactLastName"
                        class="form-control form-control-sm text-uppercase"
                        [ngClass]="{'is-invalid': isControlInvalid(f.backupContactLastName)}" placeholder="Last Name"
                        maxlength="30">
                    <app-error [isSubmit]="submit" [control]="f.backupContactLastName" [caption]="'Last Name'"
                        class="invalid-feedback">
                    </app-error>
                </div>
                <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-12">
                    <label for="" class="col-form-label" id="lblFirstName">Contact First Name</label>
                    <input type="text" id="txtbackupFirstName" formControlName="backupContactFirstName"
                        class="form-control form-control-sm text-uppercase"
                        [ngClass]="{'is-invalid': isControlInvalid(f.backupContactFirstName)}" placeholder="First Name"
                        maxlength="30">
                    <app-error [isSubmit]="submit" [control]="f.backupContactFirstName" [caption]="'First Name'"
                        class="invalid-feedback">
                    </app-error>
                </div>
                <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-12">
                    <label for="" class="col-form-label" id="lblbackupMiddleName">Middle Name</label>
                    <input type="text" id="txtbackupMiddleName" formControlName="backupContactMiddleName"
                        class="form-control form-control-sm text-uppercase"
                        [ngClass]="{'is-invalid': isControlInvalid(f.backupContactMiddleName)}"
                        placeholder="Middle Name" maxlength="30">
                    <app-error [isSubmit]="submit" [control]="f.backupContactMiddleName" [caption]="'Middle Name'"
                        class="invalid-feedback">
                    </app-error>
                </div>
                <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-12">
                    <label for="" class="col-form-label" id="lblbackupTitle">Title</label>
                    <input type="text" id="txtbackupTitle" formControlName="backupTitle"
                        class="form-control form-control-sm text-uppercase"
                        [ngClass]="{'is-invalid': isControlInvalid(f.backupTitle)}" placeholder="Title" maxlength="25">
                    <app-error [isSubmit]="submit" [control]="f.backupTitle" [caption]="'Title'"
                        class="invalid-feedback">
                    </app-error>
                </div>
                <div class="d-flex flex-column col-xl-2 col-md-auto">
                    <label class="col-form-label" id="lblbackupPhone">Phone </label>
                    <p-inputMask type="text" id="txtbackupPhone" styleClass="form-control form-control-sm"
                        formControlName="backupPhone" [ngClass]="{'is-invalid': isControlInvalid(f.backupPhone)}"
                        mask="(999)999-9999">
                    </p-inputMask>
                    <app-error [isSubmit]="submit" [control]="f.backupPhone" [caption]="'Phone'"
                        class="invalid-feedback">
                    </app-error>
                </div>
                <div class="d-flex flex-column col-xl-1 col-md-auto">
                    <label class="col-form-label" id="lblbackupExtn">Extn </label>
                    <p-inputMask type="text" id="txtbackupExtn" styleClass="form-control form-control-sm"
                        formControlName="backupPhoneExtn"
                        [ngClass]="{'is-invalid': isControlInvalid(f.backupPhoneExtn)}" mask="?99999">
                    </p-inputMask>
                    <app-error [isSubmit]="submit" [control]="f.backupPhoneExtn" [caption]="'Phone Extn'"
                        class="invalid-feedback">
                    </app-error>
                </div>
                <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-auto">
                    <label class="col-form-label" id="lblbackupEmail">Email </label>
                    <input type="text" id="txtbackupEmail" class="form-control form-control-sm"
                        formControlName="backupEmail" [ngClass]="{'is-invalid': isControlInvalid(f.backupEmail)}"
                        placeholder="Email" maxlength="50">
                    <app-error [isSubmit]="submit" [control]="f.backupEmail" [caption]="'Email'"
                        class="invalid-feedback">
                    </app-error>
                </div>
                <div class="d-flex flex-column col-xl-2 col-md-auto">
                    <label class="col-form-label" id="lblbackupFax">Fax </label>
                    <p-inputMask type="text" id="txtbackupFax" styleClass="form-control form-control-sm"
                        formControlName="backupFax" [ngClass]="{'is-invalid': isControlInvalid(f.backupFax)}"
                        mask="(999)999-9999">
                    </p-inputMask>
                    <app-error [isSubmit]="submit" [control]="f.backupFax" [caption]="'Fax'" class="invalid-feedback">
                    </app-error>
                </div>
            </div>
        </p-accordionTab >
    </p-accordion>
    <p-accordion [activeIndex]="0">
        <p-accordionTab  [header]="'Enrollment Information'"  class="mt-2">
            <div class="d-flex flex-wrap justify-content-start row">
                <div class="d-flex flex-column col-md-6 col-sm-12">
                    <label for="" class="col-form-label" id="lblFacilityType">Practice Type <app-required-label>
                        </app-required-label></label>
                    <app-select id="selFacilityType" [options]="facilityTypeList" formControlName="practiceType"
                        [ngClass]="{'is-invalid': isControlInvalid(f.practiceType)}"
                        [isInvalid]="isControlInvalid(f.practiceType)">
                    </app-select>
                    <app-error [caption]="'Practice Type'" [control]="f.practiceType" [isSubmit]="submit"
                        class="invalid-feedback">
                    </app-error>
                </div>
                <div class="d-flex flex-column col-md-6 col-sm-12">
                    <label for="" class="col-form-label" id="lblSpecialization">Specialization <app-required-label>
                        </app-required-label></label>
                    <app-select id="selSpecialization" [isMultiSelect]="true" [selectAllRequired]="true" [limitTo]="3"
                        [options]="specializationList" formControlName="specialization"
                        [ngClass]="{'is-invalid': isControlInvalid(f.specialization)}"
                        [isInvalid]="isControlInvalid(f.specialization)">
                    </app-select>
                    <app-error [caption]="'Specialization'" [control]="f.specialization" [isSubmit]="submit"
                        class="invalid-feedback">
                    </app-error>
                </div>
                <div class="d-flex flex-column col-12 together">
                    <label for="" class="col-form-label" id="lblReasonForEnrollment">Reason For Enrollment
                        <app-required-label>
                        </app-required-label></label>
                    <app-select id="selReasonForEnrollment" [options]="reasonForEnrollmentList"
                        formControlName="reasonForEnrollment" [ngClass]="{'is-invalid':
                isControlInvalid(f.reasonForEnrollment)}" [isInvalid]="isControlInvalid(f.reasonForEnrollment)"
                        (changeEvent)="reasonForEnrollmentChange()">
                    </app-select>
                    <div class="text-muted text-justify">Note: If your reason for enrollment is "Meaningful Use
                        Objective (Stage 1 Attestation Only)," NJIIS will not implement a production interface for your
                        practice.</div>
                    <app-error [caption]="'Reason For Enrollment'" [control]="f.reasonForEnrollment" [isSubmit]="submit"
                        class="invalid-feedback">
                    </app-error>
                </div>
                <div class="d-flex flex-column col-12 together" *ngIf="f.reasonForEnrollment.value === '4'">
                    <label for="" class="col-form-label" id="lblDataSubmissionOption">Data Submission Options
                        <app-required-label>
                        </app-required-label></label>
                    <app-select id="selDataSubmissionOption" [options]="dataSubmissionOptionsList"
                        formControlName="dataSubmissionOption" [ngClass]="{'is-invalid':
                isControlInvalid(f.dataSubmissionOption)}" [isInvalid]="isControlInvalid(f.dataSubmissionOption)"
                        (changeEvent)="dataSubmissionOptionChange()">
                    </app-select>
                    <app-error [caption]="'Data Submission Option'" [control]="f.dataSubmissionOption"
                        [isSubmit]="submit" class="invalid-feedback">
                    </app-error>
                </div>
                <div class="d-flex flex-column col-12 together">
                    <label for="" class="col-form-label" id="lblVaccinesAdministered">Approximate number of vaccines
                        administered in your practice per year [Please provide accurate numbers as these will be used as
                        a
                        baseline to evaluate your transmissions.]
                        <app-required-label>
                        </app-required-label></label>
                    <app-select id="selVaccinesAdministered" [options]="vaccineAdministeredList"
                        formControlName="yearlyDosesAdmin" [ngClass]="{'is-invalid':
                isControlInvalid(f.yearlyDosesAdmin)}" [isInvalid]="isControlInvalid(f.yearlyDosesAdmin)">
                    </app-select>
                    <div class="text-muted text-justify">Note: If you selected "None", please apply for the exclusion
                        for MU attestation. You do not need to submit this request form for NJIIS interface. NJIIS does
                        not process interface enrollment forms for practices that do not administer vaccines.</div>
                    <app-error [caption]="'Yearly Doses Administered'" [control]="f.yearlyDosesAdmin"
                        [isSubmit]="submit" class="invalid-feedback">
                    </app-error>
                </div>
                <div class="d-flex flex-column col-12">
                    <label for="" class="col-form-label" id="lblNumberOfPatients">Number of patients under 7 years of
                        age
                        seen at the practice
                        <app-required-label>
                        </app-required-label></label>
                    <app-select id="selNumberOfPatients" [options]="patientsUnder7YearsList"
                        formControlName="patientsUnder7Years" [ngClass]="{'is-invalid':
                isControlInvalid(f.patientsUnder7Years)}" [isInvalid]="isControlInvalid(f.patientsUnder7Years)">
                    </app-select>
                    <app-error [caption]="'Patients Under 7 Years'" [control]="f.patientsUnder7Years"
                        [isSubmit]="submit" class="invalid-feedback">
                    </app-error>
                </div>
            </div>
        </p-accordionTab >
    </p-accordion>
    <p-accordion [activeIndex]="0">
        <p-accordionTab  [header]="'Vendor Information'" class="mt-2">
            <div class="d-flex flex-wrap justify-content-start row">
                <div class="d-flex flex-column flex-md-row">
                    <p-radioButton [value]="'E'" [label]="'Existing Vendor'" [styleClass]="'ms-2'"
                        formControlName="vendorType" (onClick)="vendorTypeChange()"></p-radioButton>
                    <p-radioButton [value]="'N'" [label]="'New Vendor'" [styleClass]="'ms-2'"
                        formControlName="vendorType" (onClick)="vendorTypeChange()"></p-radioButton>
                </div>
            </div>
            <ng-container *ngIf="f.vendorType.value === 'E' || f.vendorType.value === 'N'">
                <div class="d-flex flex-wrap justify-content-start row">
                    <ng-container *ngIf="f.vendorType.value == 'N'">
                        <div class="d-flex flex-column col-6">
                            <label for="" class="col-form-label" id="lblVendorNameNew">Vendor Name <app-required-label
                                    *ngIf="isVendorRequired">
                                </app-required-label></label>
                            <input type="text" class="form-control form-control-sm text-uppercase" id="txtNewVendorName"
                                formControlName="vendorName" [ngClass]="{'is-invalid': isControlInvalid(f.vendorName)}"
                                placeholder="Alphanumeric" maxlength="100">
                            <app-error [caption]="'Vendor Name'" [control]="f.vendorName" [isSubmit]="submit"
                                class="invalid-feedback">
                            </app-error>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="f.vendorType.value == 'E'">
                        <div class="d-flex flex-column col-6">
                            <label for="" class="col-form-label" id="lblVendorNameExisting">Vendor Name
                                <app-required-label *ngIf="isVendorRequired">
                                </app-required-label></label>
                            <app-select id="selVendorName" [options]="vendorList" [label]="'vendorName'"
                                [optionValue]="'vendorIdSeq'" formControlName="vendorIdSeq"
                                [ngClass]="{'is-invalid': isControlInvalid(f.vendorIdSeq)}"
                                [isInvalid]="isControlInvalid(f.vendorIdSeq)"></app-select>
                            <app-error [caption]="'Vendor Name'" [control]="f.vendorIdSeq" [isSubmit]="submit"
                                class="invalid-feedback">
                            </app-error>
                        </div>
                    </ng-container>
                    <div class="d-flex flex-column col-6">
                        <label for="" class="col-form-label" id="lblSoftwareName">Software</label>
                        <input type="text" id="txtSoftwareName" class="form-control form-control-sm text-uppercase"
                            formControlName="softwareName" [ngClass]="{'is-invalid': isControlInvalid(f.softwareName)}"
                            placeholder="Alphanumeric" maxlength="100">
                        <app-error [caption]="'Software Name'" [control]="f.softwareName" [isSubmit]="submit"
                            class="invalid-feedback">
                        </app-error>
                    </div>
                </div>
                <div class="p-2 mb-2 card-title bg-subpanel mt-2">Primary Contact</div>
                <div class="d-flex flex-wrap justify-content-start row">
                    <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-12">
                        <label for="" class="col-form-label" id="lblvendorPrimaryLastName">Contact Last Name
                            <app-required-label *ngIf="isVendorRequired"></app-required-label></label>
                        <input type="text" id="txtvendorPrimaryLastName" formControlName="vendorPrimaryContactLastName"
                            class="form-control form-control-sm text-uppercase"
                            [ngClass]="{'is-invalid': isControlInvalid(f.vendorPrimaryContactLastName)}"
                            placeholder="Last Name" maxlength="30">
                        <app-error [isSubmit]="submit" [control]="f.vendorPrimaryContactLastName"
                            [caption]="'Last Name'" class="invalid-feedback">
                        </app-error>
                    </div>
                    <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-12">
                        <label for="" class="col-form-label" id="lblFirstName">Contact First Name <app-required-label
                                *ngIf="isVendorRequired">
                            </app-required-label></label>
                        <input type="text" id="txtvendorPrimaryFirstName"
                            formControlName="vendorPrimaryContactFirstName"
                            class="form-control form-control-sm text-uppercase"
                            [ngClass]="{'is-invalid': isControlInvalid(f.vendorPrimaryContactFirstName)}"
                            placeholder="First Name" maxlength="30">
                        <app-error [isSubmit]="submit" [control]="f.vendorPrimaryContactFirstName"
                            [caption]="'First Name'" class="invalid-feedback">
                        </app-error>
                    </div>
                    <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-12">
                        <label for="" class="col-form-label" id="lblvendorPrimaryMiddleName">Middle Name</label>
                        <input type="text" id="txtvendorPrimaryMiddleName"
                            formControlName="vendorPrimaryContactMiddleName"
                            class="form-control form-control-sm text-uppercase"
                            [ngClass]="{'is-invalid': isControlInvalid(f.vendorPrimaryContactMiddleName)}"
                            placeholder="Middle Name" maxlength="30">
                        <app-error [isSubmit]="submit" [control]="f.vendorPrimaryContactMiddleName"
                            [caption]="'Middle Name'" class="invalid-feedback">
                        </app-error>
                    </div>

                    <div class="d-flex flex-column col-xl-2 col-md-auto">
                        <label class="col-form-label" id="lblvendorPrimaryPhone">Phone <app-required-label
                                *ngIf="isVendorRequired">
                            </app-required-label></label>
                        <p-inputMask type="text" id="txtvendorPrimaryPhone" styleClass="form-control form-control-sm"
                            formControlName="vendorPrimaryPhone"
                            [ngClass]="{'is-invalid': isControlInvalid(f.vendorPrimaryPhone)}" mask="(999)999-9999">
                        </p-inputMask>
                        <app-error [isSubmit]="submit" [control]="f.vendorPrimaryPhone" [caption]="'Phone'"
                            class="invalid-feedback">
                        </app-error>
                    </div>
                    <div class="d-flex flex-column col-xl-1 col-md-auto">
                        <label class="col-form-label" id="lblvendorPrimaryExtn">Extn </label>
                        <p-inputMask type="text" id="txtvendorPrimaryExtn" styleClass="form-control form-control-sm"
                            formControlName="vendorPrimaryPhoneExtn"
                            [ngClass]="{'is-invalid': isControlInvalid(f.vendorPrimaryPhoneExtn)}" mask="?99999">
                        </p-inputMask>
                        <app-error [isSubmit]="submit" [control]="f.vendorPrimaryPhoneExtn" [caption]="'Phone Extn'"
                            class="invalid-feedback">
                        </app-error>
                    </div>
                    <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-auto">
                        <label class="col-form-label" id="lblvendorPrimaryEmail">Email <app-required-label
                                *ngIf="isVendorRequired">
                            </app-required-label></label>
                        <input type="text" id="txtvendorPrimaryEmail" class="form-control form-control-sm"
                            formControlName="vendorPrimaryEmail"
                            [ngClass]="{'is-invalid': isControlInvalid(f.vendorPrimaryEmail)}" placeholder="Email"
                            maxlength="50">
                        <app-error [isSubmit]="submit" [control]="f.vendorPrimaryEmail" [caption]="'Email'"
                            class="invalid-feedback">
                        </app-error>
                    </div>
                    <div class="d-flex flex-column col-xl-2 col-md-auto">
                        <label class="col-form-label" id="lblvendorPrimaryFax">Fax </label>
                        <p-inputMask type="text" id="txtvendorPrimaryFax" styleClass="form-control form-control-sm"
                            formControlName="vendorPrimaryFax"
                            [ngClass]="{'is-invalid': isControlInvalid(f.vendorPrimaryFax)}" mask="(999)999-9999">
                        </p-inputMask>
                        <app-error [isSubmit]="submit" [control]="f.vendorPrimaryFax" [caption]="'Fax'"
                            class="invalid-feedback">
                        </app-error>
                    </div>
                </div>
                <div class="p-2 mb-2 card-title bg-subpanel mt-2">Backup Contact</div>
                <div class="d-flex flex-wrap justify-content-start row">
                    <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-12">
                        <label for="" class="col-form-label" id="lblvendorBackupLastName">Contact Last Name </label>
                        <input type="text" id="txtvendorBackupLastName" formControlName="vendorBackupContactLastName"
                            class="form-control form-control-sm text-uppercase"
                            [ngClass]="{'is-invalid': isControlInvalid(f.vendorBackupContactLastName)}"
                            placeholder="Last Name" maxlength="30">
                        <app-error [isSubmit]="submit" [control]="f.vendorBackupContactLastName" [caption]="'Last Name'"
                            class="invalid-feedback">
                        </app-error>
                    </div>
                    <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-12">
                        <label for="" class="col-form-label" id="lblFirstName">Contact First Name </label>
                        <input type="text" id="txtvendorBackupFirstName" formControlName="vendorBackupContactFirstName"
                            class="form-control form-control-sm text-uppercase"
                            [ngClass]="{'is-invalid': isControlInvalid(f.vendorBackupContactFirstName)}"
                            placeholder="First Name" maxlength="30">
                        <app-error [isSubmit]="submit" [control]="f.vendorBackupContactFirstName"
                            [caption]="'First Name'" class="invalid-feedback">
                        </app-error>
                    </div>
                    <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-12">
                        <label for="" class="col-form-label" id="lblvendorBackupMiddleName">Middle Name</label>
                        <input type="text" id="txtvendorBackupMiddleName"
                            formControlName="vendorBackupContactMiddleName"
                            class="form-control form-control-sm text-uppercase"
                            [ngClass]="{'is-invalid': isControlInvalid(f.vendorBackupContactMiddleName)}"
                            placeholder="Middle Name" maxlength="30">
                        <app-error [isSubmit]="submit" [control]="f.vendorBackupContactMiddleName"
                            [caption]="'Middle Name'" class="invalid-feedback">
                        </app-error>
                    </div>
                    <div class="d-flex flex-column col-xl-2 col-md-auto">
                        <label class="col-form-label" id="lblvendorBackupPhone">Phone</label>
                        <p-inputMask type="text" id="txtvendorBackupPhone" styleClass="form-control form-control-sm"
                            formControlName="vendorBackupPhone"
                            [ngClass]="{'is-invalid': isControlInvalid(f.vendorBackupPhone)}" mask="(999)999-9999">
                        </p-inputMask>
                        <app-error [isSubmit]="submit" [control]="f.vendorBackupPhone" [caption]="'Phone'"
                            class="invalid-feedback">
                        </app-error>
                    </div>
                    <div class="d-flex flex-column col-xl-1 col-md-auto">
                        <label class="col-form-label" id="lblvendorBackupExtn">Extn </label>
                        <p-inputMask type="text" id="txtvendorBackupExtn" styleClass="form-control form-control-sm"
                            formControlName="vendorBackupPhoneExtn"
                            [ngClass]="{'is-invalid': isControlInvalid(f.vendorBackupPhoneExtn)}" mask="?99999">
                        </p-inputMask>
                        <app-error [isSubmit]="submit" [control]="f.vendorBackupPhoneExtn" [caption]="'Phone Extn'"
                            class="invalid-feedback">
                        </app-error>
                    </div>
                    <div class="d-flex flex-column col-xl-3 col-md-6 col-sm-auto">
                        <label class="col-form-label" id="lblvendorBackupEmail">Email </label>
                        <input type="text" id="txtvendorBackupEmail" class="form-control form-control-sm"
                            formControlName="vendorBackupEmail"
                            [ngClass]="{'is-invalid': isControlInvalid(f.vendorBackupEmail)}" placeholder="Email"
                            maxlength="50">
                        <app-error [isSubmit]="submit" [control]="f.vendorBackupEmail" [caption]="'Email'"
                            class="invalid-feedback">
                        </app-error>
                    </div>
                    <div class="d-flex flex-column col-xl-2 col-md-auto">
                        <label class="col-form-label" id="lblvendorBackupFax">Fax </label>
                        <p-inputMask type="text" id="txtvendorBackupFax" styleClass="form-control form-control-sm"
                            formControlName="vendorBackupFax"
                            [ngClass]="{'is-invalid': isControlInvalid(f.vendorBackupFax)}" mask="(999)999-9999">
                        </p-inputMask>
                        <app-error [isSubmit]="submit" [control]="f.vendorBackupFax" [caption]="'Fax'"
                            class="invalid-feedback">
                        </app-error>
                    </div>
                </div>
            </ng-container>
        </p-accordionTab >
    </p-accordion>
    <p-accordion [activeIndex]="0">
        <p-accordionTab  [header]="'Interface Information'" class="mt-2">
            <div class="d-flex flex-wrap justify-content-start row">
                <div class="d-flex flex-column col-xl-3 col-md-4 col-sm-12">
                    <label for="" class="col-form-label" id="lblIntfcAccessType">Interface Access Type
                        <app-required-label>
                        </app-required-label></label>
                    <app-select id="selIntfcAccessType" [options]="intfcAccessTypeList" [orderBy]="'DESCR'"
                        formControlName="intfcAccessType" [isInvalid]="isControlInvalid(f.intfcAccessType)" [ngClass]="{'is-invalid':
                     isControlInvalid(f.intfcAccessType)}" (changeEvent)="intfcAccessTypeChange()">
                    </app-select>
                    <div class="text-muted"><span>To read more about bi-directional messaging. <a
                                href="../../docs/NJIIS_Two_Way_Messaging_FAQs.pdf" target="_blank" class="hidden-print"
                                id="aNJIISTwoWayMessaging"> click here
                            </a></span></div>
                    <app-error [isSubmit]="submit" [caption]="'Interface Access Type'" [control]="f.intfcAccessType"
                        class="invalid-feedback">
                    </app-error>
                </div>
                <div class="d-flex flex-column col-xl-3 col-md-4 col-sm-12">
                    <label for="" class="col-form-label" id="lblIntfcType">Interface Type <app-required-label>
                        </app-required-label></label>
                    <app-select id="selIntfcType" [options]="intfcTypeList" [orderBy]="'DESCR'"
                        formControlName="intfcType" (changeEvent)="intfcTypeChange()"
                        [isInvalid]="isControlInvalid(f.intfcType)" [ngClass]="{'is-invalid':
                     isControlInvalid(f.intfcType)}">
                    </app-select>
                    <app-error [isSubmit]="submit" [caption]="'Interface Type'" [control]="f.intfcType"
                        class="invalid-feedback">
                    </app-error>
                </div>
                <div class="d-flex flex-column col-xl-3 col-md-4 col-sm-12">
                    <label for="" class="col-form-label" id="lblMessage">Message Type <app-required-label>
                        </app-required-label></label>
                    <app-select id="selMessageType" [options]="messageTypeList" formControlName="messageType"
                        [isInvalid]="isControlInvalid(f.messageType)" [ngClass]="{'is-invalid':
                     isControlInvalid(f.messageType)}" (changeEvent)="intfcAccessTypeChange()">
                    </app-select>
                    <app-error [isSubmit]="submit" [caption]="'Message Type'" [control]="f.messageType"
                        class="invalid-feedback">
                    </app-error>
                </div>
                <ng-container *ngIf="f.dataSubmissionOption.value !== '3'">
                    <div class="d-flex flex-column col-xl-3 col-md-4 col-sm-12">
                        <label for="" class="col-form-label" id="lblHL7Version">HL7 Version <app-required-label>
                            </app-required-label></label>
                        <app-select id="selHL7Version" [options]="hl7VersionList" formControlName="hl7Version"
                            [isInvalid]="isControlInvalid(f.hl7Version)" [ngClass]="{'is-invalid':
                     isControlInvalid(f.hl7Version)}" (changeEvent)="intfcAccessTypeChange()">
                        </app-select>
                        <app-error [isSubmit]="submit" [caption]="'HL7 Version'" [control]="f.hl7Version"
                            class="invalid-feedback">
                        </app-error>
                    </div>
                    <div class="d-flex flex-column col-xl-3 col-md-4 col-sm-12">
                        <label for="" class="col-form-label" id="lblEntity">Entity </label>
                        <app-select id="selEntity" [options]="enrollEntityList" formControlName="entity"
                            [isInvalid]="isControlInvalid(f.entity)" [ngClass]="{'is-invalid':
                     isControlInvalid(f.entity)}" (changeEvent)="entityChange()">
                        </app-select>
                        <app-error [isSubmit]="submit" [caption]="'Entity'" [control]="f.entity"
                            class="invalid-feedback">
                        </app-error>
                    </div>
                    <div class="d-flex flex-column col-xl-3 col-md-4 col-sm-12" *ngIf="mode === 'UPDATE'">
                        <label for="" class="col-form-label" id="lblEntityName">Entity Name <app-required-label
                                *ngIf="f.entity.value">
                            </app-required-label></label>
                        <app-select id="selEntityName" [options]="entityNameList" label="intfcEntity.intfcEntityName"
                            optionValue="entityIdSeq" [orderBy]="'INTFC_ENTITY_NAME'" formControlName="entityName"
                            (changeEvent)="entityNameChange()" [isInvalid]="isControlInvalid(f.entityName)" [ngClass]="{'is-invalid':
                     isControlInvalid(f.entityName)}">
                        </app-select>
                        <app-error [isSubmit]="submit" [caption]="'Entity Name'" [control]="f.entityName"
                            class="invalid-feedback">
                        </app-error>
                    </div>
                    <div class="d-flex flex-column col-xl-3 col-md-4 col-sm-12"
                        *ngIf="showSFTPInfo && mode === 'UPDATE'">
                        <label for="" class="col-form-label">SFTP Folder Name</label>
                        <input type="text" class="form-control form-control-sm" formControlName="sftpAccountName"
                            [ngClass]="{'is-invalid': isControlInvalid(f.sftpAccountName)}"
                            placeholder="Alphanumeric. First character should be an alphabet." maxlength="30">
                        <app-error [caption]="'SFTP Account Name'" [isSubmit]="submit" class="invalid-feedback"
                            [control]="f.sftpAccountName"></app-error>
                    </div>
                </ng-container>
            </div>
        </p-accordionTab >
    </p-accordion>
    <p-accordion [activeIndex]="0">
        <p-accordionTab  [header]="'Other Information'" class="mt-2">
            <div class="d-flex flex-wrap justify-content-start row">
                <div class="d-flex flex-column col-xl-3 col-md-4 col-sm-12">
                    <label for="" class="col-form-label" id="lblSubmittedBy">Submitted By
                        <app-required-label></app-required-label>
                    </label>
                    <input type="text" class="form-control form-control-sm text-uppercase" id="txtSubmittedBy"
                        formControlName="submittedBy" [ngClass]="{'is-invalid': isControlInvalid(f.submittedBy)}"
                        maxlength="20">
                    <app-error [caption]="'Submitted By'" [isSubmit]="submit" class="invalid-feedback"
                        [control]="f.submittedBy">
                    </app-error>
                </div>
                <div class="d-flex flex-column col-xl-3 col-md-4 col-sm-12" *ngIf="mode === 'UPDATE'">
                    <label for="" class="col-form-label" id="lblSubmittedOn">Submitted On </label>
                    <label for="" class="col-form-label font-weight-normal"
                        id="lblSubmittedOnData">{{enrollmentData?.dateCreated}}
                    </label>
                </div>
            </div>
            <div class="d-flex flex-wrap justify-content-start row" *ngIf="mode === 'UPDATE'">
                <div class="d-flex flex-column col-12">
                    <label for="" class="col-form-label" id="lblOldComments">Previous Comments</label>
                    <textarea pInputTextarea autoResize="autoResize" id="txtOldComments" formControlName="oldComments"
                        class="form-control form-control-sm" rows="8" cols="30"></textarea>
                </div>
            </div>
            <div class="d-flex flex-wrap justify-content-start row">
                <div class="d-flex flex-column col-12">
                    <label for="" class="col-form-label" id="lblComments">Comments <app-required-label
                            *ngIf="mode === 'UPDATE'">
                        </app-required-label></label>
                    <textarea id="txtComments" formControlName="comments"
                        [ngClass]="{'is-invalid': isControlInvalid(f.comments)}" class="form-control form-control-sm"
                        maxlength="1500" rows="8" cols="30"></textarea>
                    <app-error [caption]="'Comments'" [isSubmit]="submit" class="invalid-feedback"
                        [control]="f.comments">
                    </app-error>
                </div>
            </div>
        </p-accordionTab >
    </p-accordion>
</form>